import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import PlotAnalysis from "@/pages/special/plot-analysis/page";
import Guide from "@/pages/guide/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/detail/:id",
    element: <Detail />,
  },
  {
    path: "/special/plot-analysis",
    element: <PlotAnalysis />,
  },
  {
    path: "/guide",
    element: <Guide />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;